import { classNames } from "./classNames";

/** `small` in side panels and form headers, `regular` at the top of a page. */
export type SwitcherSize = "small" | "regular";

const SIZE_CLASS: Readonly<Record<SwitcherSize, string>> = {
  small: "px-2 py-0.5 text-xs",
  regular: "px-3 py-1 text-sm",
};

/** One option of a tab list or segmented control; the chosen one is highlighted. */
export function switcherOptionClassName(size: SwitcherSize, chosen: boolean): string {
  return classNames("app-page-switcher-button rounded", SIZE_CLASS[size], chosen && "app-nav-item-active");
}
